var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.758,
    height: 15.586,
    viewBox: "0 0 13.758 15.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17937.01 18551)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17937.01 -18551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4,15.586A6.64,6.64,0,0,0,61.87,8.973c0-2.086-1.5-4.452-2.036-5.234a.206.206,0,0,0-.349.015l-.384.672a.206.206,0,0,1-.364-.011l-.962-1.944a.206.206,0,0,0-.346-.037l-.517.648a.206.206,0,0,1-.348-.04L55.178.118a.206.206,0,0,0-.373,0L53.419,3.043a.206.206,0,0,1-.348.04l-.517-.648a.206.206,0,0,0-.346.037l-.962,1.944a.206.206,0,0,1-.364.011L50.5,3.755a.206.206,0,0,0-.349-.015c-.538.782-2.036,3.148-2.036,5.234a6.64,6.64,0,0,0,4.471,6.613H57.4Z",
    transform: "translate(-48.112 0)",
    fill: "#ff5600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.46,113.067s2.756-.982,2.756-4.769a7.684,7.684,0,0,0-1.432-3.721.189.189,0,0,0-.321.012l-.207.363a.189.189,0,0,1-.334-.01l-.633-1.278a.189.189,0,0,0-.317-.034L98.68,104a.189.189,0,0,1-.319-.037l-.936-1.975a.189.189,0,0,0-.342,0l-.936,1.975a.189.189,0,0,1-.319.037l-.294-.368a.189.189,0,0,0-.317.034l-.633,1.278a.189.189,0,0,1-.334.01l-.207-.363a.189.189,0,0,0-.321-.012,7.684,7.684,0,0,0-1.432,3.721c0,3.788,2.756,4.769,2.756,4.769Z",
    transform: "translate(-90.376 -97.481)",
    fill: "#f7e365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpact);
export default __webpack_public_path__ + "static/media/impact.f5fe2217018c1c1f6b0ac22e2a013994.svg";
export { ForwardRef as ReactComponent };